<template>
  <HorizontalFacets
    ref="horizontalFacets"
    name="facet"
    class="filter-optimize-dnf"
    :options="facetsOptions"
    :disable-auto-outlined="true"
    @onFacetClick="onFacetClickLocal"
    @onCloseFacetDropdown="onCloseFacetDropdown"
  />
</template>

<script setup>
import { computed } from 'vue';
import HorizontalFacets from '@atomic-ui/horizontalFacets';
import useFacetsList from '../composables/useFacetsList';
import useHorizontalFacetsRef from '../composables/useHorizontalFacetsRef';

const horizontalFacets = useHorizontalFacetsRef();
const {
  onCloseFacetDropdown, facetsOptions, onFacetClickLocal,
} = useFacetsList();

const defaultDropdownHeight = '450px';

const contentHeight = computed(() => {
  if (typeof window !== 'undefined') {
    return window.innerHeight > 760 ? defaultDropdownHeight : 'calc(100vh - 350px)';
  }
  return defaultDropdownHeight;
});

</script>

<style lang="scss" scoped>
  @import "src/scss/mixins";

  @include breakpoint(large) {
    :deep(button.csg-horizontal-facet:hover) {
      background-color: #f1f1f1;
    }

  }

  .filter-optimize-dnf {
    :deep(.checkbox-container) {
        scrollbar-width: auto;
        margin-right: rem-calc(0);
    }

    :deep(.all_brands_label) {
      margin-bottom: 16px !important;
    }

    :deep(.all_designers_label) {
      margin-bottom: 16px !important;
    }

    :deep(.checkbox-container .checkbox-wrapper .title) {
      margin: 0px 0 16px !important;
    }
  }

  :deep(.checkBoxesContainer) {
    @include customScrollbar();
  }

  :deep(.checkBoxesContainer) {
    max-height: v-bind(contentHeight);
  }

  :deep(.dropdown.opened) {
    display: flex;
    flex-direction: column;

    .facetContainer {
      display: flex;
      flex-direction: column;
    }
  }

</style>
